import type React from 'react';

/** A card's own controls (the poster, its actions, the stats): a tap on one stays that control's, a disabled one
 *  included (a tap on a disabled action does nothing rather than open the ad). */
const ROW_CONTROL = 'button, a[href], input, select, textarea, label';

/**
 * A library row's click: opens the ad unless the tap landed on one of the row's own controls. On a phone a library
 * card is a row (a small poster beside the details), and the whole row opens it, not only the poster.
 */
export const openRowUnlessControl = (event: React.MouseEvent<HTMLElement>, open: () => void): void => {
  const control = event.target instanceof Element ? event.target.closest(ROW_CONTROL) : null;
  if (control && event.currentTarget.contains(control)) return;
  open();
};
